import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { filter, lastValueFrom, map } from 'rxjs';
import { Location } from '@angular/common';
import { ActivityManagerService } from '../services/views/activity-manager.service';
import { web_url } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { StatisticsService } from '../services/statistics.service';

@Injectable()
export class LoggedInGuard {

    private alreadyValidated: boolean = false;
    eventoUrl

    constructor(private auth: AuthService, private location: Location, private route: ActivatedRoute, private statsService: StatisticsService,
        private activityManager: ActivityManagerService) { }

    private getCookie(name: string): string | null {
        const match = document.cookie.match(
        new RegExp('(^| )' + name + '=([^;]+)')
        );

        return match ? decodeURIComponent(match[2]) : null;
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (this.alreadyValidated) return true;

        this.eventoUrl = route.queryParamMap.get('slug');

        let siteVisitTimestamp: string | null = route.queryParamMap.get('site_visit_timestamp') ?? '';
        let siteVisitIdParam: string = route.queryParamMap.get('site_visit_id')?? '';
        let siteVisitId: string | null = siteVisitIdParam !== null ? siteVisitIdParam : null;

        if(siteVisitId === ''){
            siteVisitId = this.getCookie('cuentame_site_visit_uuid')
            siteVisitTimestamp = this.getCookie('cuentame_site_visit_timestamp')
        }

        try {
            await this.activityManager.loadAcitvityManager();
            siteVisitId = this.getCookie('cuentame_site_visit_uuid')
            siteVisitTimestamp = this.getCookie('cuentame_site_visit_timestamp')
            this.statsService.siteVisitUuid = siteVisitId
            // this.statsService.siteVisitUuid = siteVisitTimestamp
        } catch (error) {
            console.log('ERROR ',error)
        }
        console.log('ENTRO AL LOG')
        console.log('SITEVISIT', siteVisitId)

        console.log('sitevistime', siteVisitTimestamp)
        if (!this.validateSiteVisit(siteVisitId, siteVisitTimestamp!)) return this.invalid();


        this.alreadyValidated = true;
        return true;
    }

    private validateSiteVisit(siteVisitId: string | null, siteVisitTimestamp: string): boolean {
        if (!siteVisitId || siteVisitId === '') return false;
        if (!siteVisitTimestamp) return false;
        return true;
    }

    private parseJwt(token: string): any {
        if (token) {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace('-', '+').replace('_', '/');
            return JSON.parse(window.atob(base64));
        }
    }

    private invalid(): boolean {
        // this.auth.logout();
        console.log('INVALIDO')
        console.trace('Invalid')
        
        document.location.href = `${web_url}?eventoUrl=${this.eventoUrl}`;
        return false;
    }
}